var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex -mx-3"},[_c('div',{staticClass:"w-24 px-3"}),_c('div',{staticClass:"flex-1 px-3"},[_vm._v("Name")]),(_vm.$isAdminOrSuperAdmin)?_c('div',{staticClass:"flex-1 px-3"},[_vm._v("Membership product")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }